<template>
  <section class="after-sale">
    <div class="header">
      <div class="name">2亿车主的ETC助手</div>
      <div class="tip">很高兴为您提供服务</div>
      <img
        class="logo"
        src="https://wecos.etczs.net/H5/afterSale/etc-logo.png"
      />
    </div>
    <div class="module service">
      <div class="module-title">自助服务</div>
      <div class="service-list" @click="showCodePoster">
        <template v-for="(ele, i) in serviceList">
          <div class="item"  :key="i" v-if="ele.icon">
            <img class="icon" :src="ele.icon" />
            <div class="text">{{ ele.name }}</div>
          </div>
        </template>
      </div>
    </div>
    <div class="module qa-list">
      <div class="module-title">猜你想问</div>
        <div class="qa-item" :class="qa.selectEd ? 'select' : ''" v-for="(qa, i) in qaList" :key="i" >
          <div class="qa-title" @click="selectQa(i)">
            <div class="text">{{ qa.title }}</div>
            <img class="arrow" src="https://wecos.etczs.net/invoice-manage/invoice-manage-arrow-r.png"/>
          </div>
          <div class="qa-content" >
            <div class="text" v-for="(ele, inx) in qa.content" :key="inx">{{ ele }}</div>
          </div>

        </div>
    </div>
    <div class="bottom">
      <div class="btn" @click="m_customService">
         <img
        class="icon"
        src="https://wecos.etczs.net/H5/afterSale/after-service-icon.png"
      />
      <txt class="text">在线客服</txt>

      </div>
    </div>
    <Popup
      ref="popup"
      class="poster-con"
    >
      <div
        slot="content"
        class="poster"
      >
        <img
          class="poster-img"
          src="../../assets/afterSale/after-sale-poster.png"
          width="620"
          height="952"
        >
      </div>
    </Popup>
  </section>
</template>
<script>
import FunMixin from '@/mixins/funMixin'
import BiMixin from '@/mixins/biMixin'
import ChannlMixin from '@/mixins/channelMixin'
import Popup from '@/components/cool.popup'
import UserApi from '@/api/user.api'

// import ETC from '@/config/etc.config'

const imgBaseUrl = 'https://wecos.etczs.net/H5/afterSale/'

const AFTERSALE_SERVICE_LIST = [
  {
    name: '设备激活',
    icon: imgBaseUrl + 'after-item-icon-01.png'
  },
  {
    name: 'ETC补办',
    icon: imgBaseUrl + 'after-item-icon-02.png'
  },
  {
    name: 'ETC注销',
    icon: imgBaseUrl + 'after-item-icon-03.png'
  },
  {
    name: '维修换货',
    icon: imgBaseUrl + 'after-item-icon-04.png'
  },
  {
    name: '退货退款',
    icon: imgBaseUrl + 'after-item-icon-05.png'
  },
  {
    name: '更多服务',
    icon: imgBaseUrl + 'after-item-icon-06.png'
  }
]
const QA_LIST = [
  {
    title: 'ETC激活成功没有怎么看？',
    content: [
      '1.通过系统判断：微信办理ETC的用户，设备激活成功后，页面会提示”激活成功“字样，点击确认后会进入ETC助手的个人中心页面；',
      '2.通过设备判断：将ETC卡片从电子标签设备中拔出再插入，设备屏幕显示只显示“记账卡”即为已激活的正常状态。'
    ],
    selectEd: false
  },
  {
    title: '设备显示“标签失效”怎么办？',
    content: [
      '未激活成功的设备上显示屏提示“标签失效”、“非法拆卸”是正常的，请按照ETC助手微信小程序指引完成激活流程，设备即可正常使用。若已激活的设备，请在个人中心-客服中心-标签失效/拆卸，申请重新激活即可。'
    ],
    selectEd: false
  },
  {
    title: 'ETC设备丢了怎么办？',
    content: [
      '有以下两种方式',
      '1.ETC助手用户可支持在线补办业务，登录ETC助手微信小程序，进入个人中心的快捷工具功能，即可轻松办理补卡补设备。',
      '2.其他渠道的用户可到发卡方线下网点办理挂失、补办业务'
    ],
    selectEd: false
  },
  {
    title: '已经发货如何退货退款？',
    content: [
      '在ETC助手微信小程序的客服中心选择“退货退款”服务申请退货和退款，仓库签收寄回设备后需要请求发卡方做解约，解约成功后支付金额将原路返还。'
    ],
    selectEd: false
  }
]

export default {
  name: 'afterSale',
  mixins: [FunMixin, ChannlMixin, BiMixin],
  components: {
    Popup
  },
  data() {
    return {
      serviceList: AFTERSALE_SERVICE_LIST,
      qaList: QA_LIST,
      isIphoneX: false
    }
  },
  computed: {
  },
  methods: {
    selectQa(i) {
      console.log(3214234234, i)
      this.qaList.forEach((ele, inx) => {
        if (inx === i) {
          ele.selectEd = !ele.selectEd
        } else {
          ele.selectEd = false
        }
      })
    },
    showCodePoster() {
      this.m_showLoading()
      UserApi.getUserInfo()
        .then(userInfo => {
          this.m_loadingClose()
          if (userInfo.is_binded) {
            this.$refs.popup.$emit('showPopup', { wrapClass: 'wrap-trans', maskHide: true })
          } else {
            this.m_showConfirm({ content: '请先到【ETC助手】公众号或小程序完成车牌绑定与资料填写', noCancel: true, confirmBtn: '我知道了' })
          }
        })
        .catch(() => {
          this.$refs.popup.$emit('showPopup', { wrapClass: 'wrap-trans', maskHide: true })
        })
    }
  },
  mounted() {},
  async created() {
  }
}
</script>
<style scope lang="scss">
.after-sale {
  background-color: #F8F7F6;
  padding-bottom: 136px;
  .header {
    height: 352px;
    background: linear-gradient(
      180deg,
      #19c88c 0,
      #19c88c 152px,
      rgba(25, 200, 140, 0) 352px
    );
    box-sizing: border-box;
    padding: 40px 28px 0;
    position: relative;
    .logo {
      position: absolute;
      width: 100px;
      height: 100px;
      top: 48px;
      right: 48px;
    }
    .name {
      font-size: 48px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 67px;
    }
    .tip {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      margin-top: 8px;
    }
  }
  .module {
    background: #ffffff;
    border-radius: 12px;
    width: 694px;
    box-sizing: border-box;
    padding: 28px;
    margin: 0 auto;
    .module-title {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 50px;
    }
    &.service {
      position: relative;
      margin-top: -164px;
      padding-bottom: 36px;
      .service-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      .item {
        margin: 44px 50px 0;

      }
      .icon {
        display: block;
        margin: 0 auto;
        width: 68px;
        height: 68px;
      }
      .text {
        margin: 0 auto 0;

        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        margin-top: 8px;
        text-align: center;
      }
    }
    &.qa-list {
      margin-top: 28px;
      padding-bottom: 0;
      .qa-item {
        border-bottom: 1px solid #e8e8e8;
        padding: 28px 0;
        &:last-child {
          border-bottom: none;
        }
        &.select {
          padding-bottom: 24px;
          .arrow {
            transform: rotate(-90deg);
          }
          .qa-content  {
            max-height: 500px;
            margin-top: 12px;
          }
        }
        .qa-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 45px;
        }
        .arrow {
          display: block;
          width: 28px;
          height: 28px;
          transform: rotate(90deg);
        }
        .qa-content {
          font-size: 28px;

          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 42px;
          max-height: 0px;
          overflow: hidden;
          transition: all .3s;
        }
      }
    }
  }
  .bottom {
    height: 122px;
    background-color: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    .btn {
      line-height: 112px;
      text-align: center;
      .icon {
        margin-right: 16px;
        width: 40px;
        height: 40px;
        vertical-align: middle;

      }
      .text {
        display: inline-block;
        vertical-align: middle;

        font-size: 32rpx;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #16C88B;
      }
    }
  }

}
.poster {
  .poster-img {
    width: 620px;
    height: 952px;
  }
}
</style>
